export enum UserStatus {
    Active,
    Inactive
}

